// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2aYmA","rightAdornment":"Header_rightAdornment__24TCz"};